interface IconPhoneHotlineProps {
  className?: string
}
// Icon điện thoại nền trắng của nút hotline - cùng hình với
// /assets/icons/icon-phone-1.svg bên bản desktop (nk-desktop-web1).
export const IconPhoneHotline = ({ className }: IconPhoneHotlineProps) => {
  return (
    <svg
      className={className}
      width='52'
      height='52'
      viewBox='0 0 46 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='23' cy='23' r='23' fill='white' />
      <path
        d='M29.323 24.6007C28.904 24.1818 28.1919 24.1818 27.773 24.6007L25.3432 27.0304C24.2122 28.1615 21.6567 27.4074 19.604 25.3547C17.5513 23.302 16.7973 20.7466 17.9284 19.6155L20.3581 17.1858C20.777 16.7669 20.777 16.0547 20.3581 15.6358L14.7865 10.0642C14.3676 9.64527 13.6554 9.64527 13.2365 10.0642L11.6027 11.698C8.33513 14.9655 10.5135 22.4642 16.504 28.4547C22.4946 34.4453 29.9932 36.6655 33.2608 33.3561L34.8946 31.7223C35.3135 31.3034 35.3135 30.5912 34.8946 30.1723L29.323 24.6007Z'
        fill='#FF0000'
      />
      <path
        d='M23.6257 8.0964C23.0811 8.0545 22.6622 8.51532 22.7041 9.1018C22.746 9.52072 23.1649 9.85586 23.5838 9.89775C29.7838 10.3167 34.727 15.3018 35.146 21.5018C35.1878 21.9626 35.5649 22.3396 36.0257 22.3396C36.5284 22.3396 36.9473 21.9207 36.9054 21.3761C36.4446 14.2545 30.7473 8.55721 23.6257 8.0964Z'
        fill='#FF0000'
      />
      <path
        d='M23.5419 14.2958C27.3121 14.6728 30.3284 17.689 30.7054 21.5012C30.7473 21.962 31.1243 22.2972 31.5851 22.2972C32.0878 22.2972 32.5067 21.8363 32.4648 21.3336C32.004 16.6836 28.3175 12.9553 23.6675 12.4945C23.0811 12.4526 22.5784 12.9972 22.7459 13.6255C22.8297 14.0445 23.1648 14.2539 23.5419 14.2958Z'
        fill='#FF0000'
      />
    </svg>
  )
}
